// extracted by mini-css-extract-plugin
export default {"gamesStatus":"styles_gamesStatus__0WOPv"};